import { css } from '@emotion/react'
import { INVESTOR_TOP_LIST_COUNT } from '../../../pages/investors/[shortname]'
import { Investments } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { CurrentInvestments } from './CurrentInvestments'
import { IpoSummaryList } from './IpoSummaryList'
import { LeadingVCCompanyList } from './LeadingVCCompanyList'
import { PastInvestments } from './PastInvestments'
import { ViewMoreLink } from '../../common/ViewMoreLink'
import React from 'react'

type Props = {
  shortname: string
  investments: Omit<Investments, 'lp'>
}

export const VBInvestments: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle
        helpText="直接投資、あるいはGPとして運営しているファンドからの投資"
        helpProps={{ size: 'large' }}
      >
        スタートアップ投資
      </CardTitle>
      <CurrentInvestments
        list={props.investments.current.data}
        investorShortName={props.shortname}
      />
      <ViewMoreLink
        isHidden={props.investments.current.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/details-current?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/details-current`}
        count={props.investments.current.count}
      />
      <PastInvestments
        list={props.investments.past.data}
        css={css`
          margin-top: 2rem;
        `}
      />
      <ViewMoreLink
        isHidden={props.investments.past.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/details-past?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/details-past`}
        count={props.investments.past.count}
      />
      <LeadingVCCompanyList
        list={props.investments.leading.data}
        css={css`
          margin-top: 2rem;
        `}
      />
      <ViewMoreLink
        isHidden={props.investments.leading.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/details-leading?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/details-leading`}
        count={props.investments.leading.count}
      />
      <IpoSummaryList
        list={props.investments.ipo.data}
        css={css`
          margin-top: 2rem;
        `}
      />
      <ViewMoreLink
        isHidden={props.investments.ipo.count <= INVESTOR_TOP_LIST_COUNT}
        href={`/investor/details-ipo?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/details-ipo`}
        count={props.investments.ipo.count}
      />
    </>
  )
}
